"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utf8 = exports.getAcceptCharsetHeader = void 0;
function getAcceptCharsetHeader() {
    return `accept-charset`;
}
exports.getAcceptCharsetHeader = getAcceptCharsetHeader;
function Utf8() {
    return `utf-8`;
}
exports.Utf8 = Utf8;
